import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import debounce from 'lodash.debounce'
import SessionTypes from '../../../constants/session/types'
import authService from '../../../services/auth'
import { fetchEmployees } from '../../../states/actions/employee'
import { EmployeeMenu } from '../../../constants'
import { employeeService } from '../../../services'
import { apiHostname } from '../../../config'
import { formatter, queryString } from '../../../util'

// UI
import { ControlLabel, Page, Pager, SearchInput } from '../../../components'
import notify from '../../../components/Notification'

import './styles.css'

import Col from 'antd/lib/col'
import Row from 'antd/lib/row'
import Icon from 'antd/lib/icon'
import Select from 'antd/lib/select'
import Skeleton from 'antd/lib/skeleton'
import Tooltip from 'antd/lib/tooltip'

const pageSize = 40
const Option = Select.Option

export class Employee extends Component {
  constructor (props) {
    super(props)
    const { employees: { list, total }, loading } = props
    this.state = {
      employeeIds: [],
      currentPage: 1,
      filter: { active: true },
      list,
      loading,
      searching: false,
      searchText: '',
      sort: {},
      suburbs: [],
      total
    }
    this.onSearchName = debounce(this.onSearchName, 500)
    this.handleSelectStatus = this.handleSelectStatus.bind(this)
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    const { employees: { list, total }, loading } = nextProps
    const state = { ...prevState, list, loading, total }
    if (list !== prevState.list) {
      state.searching = false
    }
    return state
  }

  componentDidMount () {
    const { currentPage, filter, loading, searchText, sort } = this.state
    this.fetchEmployees({ currentPage, filter, loading, searchText, sort })
  }

  onSearchName (value) {
    const { filter, loading, sort } = this.state
    this.setState({ searching: true })

    if (value && value.indexOf(' ') >= 0) {
      const words = value.split(' ')
      if (Array.isArray(words)) {
        filter.$and = []

        for (let i = 0; i < words.length; i++) {
          filter.$and.push({
            $or: [
              { first_name: { condition: 'ilike', value: `%${words[i]}%` } },
              { last_name: { condition: 'ilike', value: `%${words[i]}%` } },
              { acc_ref: { condition: 'ilike', value: `%${words[i]}%` } },
              { suburb: { condition: 'ilike', value: `%${words[i]}%` } }
            ]
          })
        }
      }
    } else {
      if (Array.isArray(filter.$and)) {
        delete filter.$and
      }
    }
    this.fetchEmployees({ currentPage: 1, filter, loading, searchText: (filter.$and ? '' : value), sort })
    this.setState({ searchText: value, currentPage: 1 })
  }

  // onSelectActive (value) {
  //   const { currentPage, filter, loading, searchText, sort } = this.state
  //   filter.active = value

  //   this.fetchEmployees({ currentPage, filter, loading, searchText, sort })
  //   this.setState({ filter })
  // }

  // handleSelectStatus (value) {
  //   const { currentPage, filter, searchText, sort } = this.state
  //   if (value === 'active' || value === 'inactive') {
  //     filter.active = (value === 'active')
  //     filter.is_resigned = false
  //   } else if (value === 'resigned') {
  //     filter.active = false
  //     filter.is_resigned = true
  //   }

  //   this.fetchEmployees({ currentPage, filter, loading: true, searchText: (filter.$and ? '' : searchText), sort })
  //   this.setState({ filter })
  // }

  handleSelectStatus (value) {
    const { currentPage, filter, searchText, sort } = this.state
    if (value === 'active') {
      filter.active = (value === 'active')
    } else if (value === 'inactive') {
      filter.active = false
    }

    this.fetchEmployees({ currentPage, filter, loading: true, searchText: (filter.$and ? '' : searchText), sort })
    this.setState({ filter })
  }

  hasAccess (accessLevel) {
    return authService.hasAccess(accessLevel)
  }

  render () {
    const { currentPage, list, loading, searching, total } = this.state

    return (
      <Page.Body>
        <Page.Left>
          <Page.Menu title='Home' menu={EmployeeMenu} />
        </Page.Left>
        <Page.Content full>
          <Page.Header title='Employees'>
            <Link to='/employees/add'>
              {
                this.hasAccess('createEmployee') ? <div className='btn'>
                Add
                </div>
                  : null
              }
            </Link>
          </Page.Header>

          <Page.Filter>
            <Row gutter={8}>
              <Col lg={8}>
                <ControlLabel>Name, Acc Ref ID, Suburb</ControlLabel>
                <SearchInput placeholder='Search employees' onChange={(v) => this.onSearchName(v)} isSearching={searching} />
              </Col>
              <Col lg={8}>
                <ControlLabel>Status</ControlLabel>
                <Select defaultValue='active' style={{ width: 120 }} onChange={this.handleSelectStatus}>
                  <Option value='active'>Active</Option>
                  <Option value='inactive'>Inactive</Option>
                  {/* <Option value='resigned'>Resigned</Option> */}
                </Select>
              </Col>
            </Row>
          </Page.Filter>

          <div className='employees'>
            <Skeleton loading={loading} active avatar>
              {list.map((item) => {
                const { id, first_name, last_name, acc_ref, gender, suburb, active, leave_id, leave_start, leave_end } = item

                return (
                  <Link to={`/employees/${id}`} key={id}>
                    <div className={`list-item ${active ? '' : 'list-item-dim'}`}>
                      <Row className='list-content'>
                        <Col md={6}><img alt='' src={process.env.PUBLIC_URL + '/img/' + (gender && gender.toLowerCase() === 'male' ? 'man.png' : 'woman.png')} className='avatar' /></Col>

                        <Col md={18}>
                          <div className='name'>{first_name} {last_name} { leave_id ? <Tooltip title={`Leave ${formatter.toShortDate(leave_start)} - ${formatter.toShortDate(leave_end)}`} mouseEnterDelay={0} mouseLeaveDelay={0}><Icon type='exclamation-circle' theme='twoTone' twoToneColor='#ff0000' /></Tooltip> : null }</div>
                          <div style={{ fontSize: '8pt' }}>{acc_ref}</div>
                          <div style={{ marginTop: '3px', fontSize: '8pt', color: '#888' }}>{suburb}</div>
                        </Col>

                      </Row>
                    </div>
                  </Link>
                )
              })}
            </Skeleton>
          </div>

          <Pager
            size={pageSize}
            total={total}
            totalText={`Total ${total} employees`}
            current={currentPage}
            onChange={this.changePage}
            style={{ marginTop: '15px' }}
          />
        </Page.Content>
      </Page.Body>
    )
  }

  changePage = (currentPage) => {
    const { filter, searchText, sort } = this.state
    this.fetchEmployees({ currentPage, filter, searchText, sort })
  }

  fetchEmployees = async ({ loading = true, currentPage = 1, filter = {}, sort = {}, searchText }) => {
    try {
      const { fetchEmployees } = this.props
      this.setState({ currentPage })
      fetchEmployees({ loading, currentPage, pageSize, filter, sort, searchText })
    } catch (e) {
      notify.error('Unable to load successfully', 'Unable to load employees successfully. Please try again later.')
    }
  }
}

const mapDispatchToProps = {
  fetchEmployees
}

const mapStateToProps = (state) => {
  return { ...state.Employee }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Employee)
